import React from "react";
import DungeonMap from "./components/DungeonMap";
 
function App() {
  return <DungeonMap />;
}
 
export default App;